import { useEffect, useRef, useState } from 'react';
import { ETestIds } from '../../../../constants/testIds';
import { EScrollUpButtonType } from '../types';
import { getDataTestIdByType } from '../utils';

export const useScrollUpButton = () => {
  const [type, setType] = useState<EScrollUpButtonType>(EScrollUpButtonType.Filters);
  /** До монтирования на клиенте не подмешиваем вывод IntersectionObserver — иначе расхождение SSR/гидрации. */
  const [isClientMounted, setIsClientMounted] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const displayType = isClientMounted ? type : EScrollUpButtonType.Filters;
  const scrollTargetTestId = getDataTestIdByType(displayType);

  const scrollTo = (testId: string) => () => {
    const calculator = document.querySelector(`[data-testid=${testId}]`) as Element;
    calculator?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    setIsClientMounted(true);
  }, []);

  useEffect(() => {
    const offerList = document.querySelector(`[data-testid=${ETestIds.OfferList}]`) as Element;
    if (!offerList) {
      return;
    }

    const scrollUpButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setType(EScrollUpButtonType.Filters);
          } else {
            setType(EScrollUpButtonType.Up);
          }
        });
      },
      {
        threshold: 0.01,
      },
    );

    scrollUpButtonObserver.observe(offerList);

    return () => {
      scrollUpButtonObserver.disconnect();
    };
  }, []);

  return {
    type: displayType,
    buttonRef,
    scrollToBlock: scrollTo(scrollTargetTestId),
  };
};
